import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import Text from "@sproutsocial/seeds-react-text";
import { Icon } from "@sproutsocial/seeds-react-icon";
import type { TypeListItemContentProps } from "./ListItemTypes";

/**
 * Styled-components implementation of ListItemContent. Used by
 * ListItemContentHybrid whenever a consumer passes a styled-system prop or a
 * styled() extension. This is the unchanged legacy rendering path (Box/Text/Icon
 * composition).
 */
const ListItemContentStyled = ({
  text,
  details,
  aside,
  iconName,
  iconLabel,
  actions,
  ...rest
}: TypeListItemContentProps) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      borderRadius="outer"
      alignItems="baseline"
      {...rest}
    >
      <Box display="flex" flex="1">
        {iconName && (
          <span>
            <Icon mr={300} name={iconName} size="small" ariaLabel={iconLabel} />
          </span>
        )}
        <Box flex="1">
          <Text.SmallSubHeadline as="div">{text}</Text.SmallSubHeadline>
          {details && (
            <Text.Byline as="div" mt={200}>
              {details}
            </Text.Byline>
          )}
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap={300} flexShrink={0}>
        {aside && <Text.Byline as="div">{aside}</Text.Byline>}
        {actions && (
          <Box display="flex" alignItems="center">
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
};

ListItemContentStyled.displayName = "ListItemContent";

export default ListItemContentStyled;
